import {
  Inject,
  Injectable,
} from 'ng-metadata/core';

@Injectable()
export class SessionService {
  public session: any;

  constructor(
    @Inject('$q') private $q: ng.IQService,
    @Inject('$log') private $log: ng.ILogService,
    @Inject('$http') private $http: ng.IHttpService,
    @Inject('$window') private $window: Window,
  ) {
    window['Promise'] = this.$q;
  }

  async getState(key = 'order-cart') {
    if (this.session) {
      return this.session;
    }

    try {
      const session = await this.$http.get(`/state/${key}`);
      this.session = session.data;
    } catch (e) {
      this.session = null;
      throw e;
    } finally {
      return this.session;
    }
  }

  async saveState(data, newState = false): Promise<any> {
    try {
      const response = await this.$http.post('/state/save', data);
      return this.handleSuccess(response);
    } catch (e) {
      throw e;
    }
  }

  async resetState(key = 'order-cart') {
    try {
      const response = await this.$http.post(`/state/reset/${key}`, {});
      this.session = {};
      return this.session;
    } catch (e) {
      throw e;
    }
  }

  handleSuccess(response) {
    if (response.data) {
      return response.data;
    }

    return false;
  }

  handleError(response) {
    return this.$q.reject(response);
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/services/session.service.ts